import * as React from 'react'
import { Flags } from '@lacedltd/laced-components'
import { useTranslation, useLocale } from 'hooks'
import * as S from '../SiteSettings.styles'

const SiteSettingsTrigger = ({ ...rest }) => {
  const { location, currency } = useLocale()
  const { t } = useTranslation()

  return (
    <S.Trigger
      {...rest}
      data-testid="toggle-site-settings"
      data-location={location.code}
      data-currency={currency}
    >
      <Flags code={location.code} />
      {t(`shared.locales.currency.${currency}`)}
    </S.Trigger>
  )
}

export default SiteSettingsTrigger
